import script from "./HeroView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroView.vue?vue&type=script&setup=true&lang=js"

import "./HeroView.vue?vue&type=style&index=0&id=53c6f25a&lang=scss"

const __exports__ = script;

export default __exports__